import { FC, useEffect } from 'react';

interface ICalculadoradenatalmetapapiProps {
  btnUrl: string;
}
const Calculadoradenatalmetapapi: FC<ICalculadoradenatalmetapapiProps> = ({ btnUrl }) => {
  useEffect(() => {
    const dailyLevels = [
      { points: 2500, reward: 5, level: 1, name: 'Aprendiz' },
      { points: 7500, reward: 10, level: 2, name: 'Escudeiro' },
      { points: 15000, reward: 20, level: 3, name: 'Cavaleiro' },
      { points: 30000, reward: 50, level: 4, name: 'Sentinela' },
      { points: 100000, reward: 100, level: 5, name: 'Guardião' },
      { points: 250000, reward: 250, level: 6, name: 'Marechal' },
      { points: 500000, reward: 500, level: 7, name: 'Regente' },
      { points: 750000, reward: 1000, level: 8, name: 'Capitão' },
      { points: 1000000, reward: 2500, level: 9, name: 'Comandante' },
      { points: 1250000, reward: 7500, level: 10, name: 'Monarca' },
      { points: 1500000, reward: 15000, level: 11, name: 'Soberano' },
      { points: 1750000, reward: 25000, level: 12, name: 'Supremo' },
    ];

    const weeklyLevels = [
      { points: 1000, reward: 2, level: 1, name: 'Latão Natal' },
      { points: 2500, reward: 5, level: 2, name: 'Cobre Natal' },
      { points: 7500, reward: 10, level: 3, name: 'Bronze Natal' },
      { points: 15000, reward: 20, level: 4, name: 'Prata Natal' },
      { points: 30000, reward: 50, level: 5, name: 'Ouro Natal' },
      { points: 100000, reward: 100, level: 6, name: 'Platina Natal' },
      { points: 250000, reward: 250, level: 7, name: 'Diamante Natal' },
      { points: 500000, reward: 500, level: 8, name: 'Épico Natal' },
      { points: 750000, reward: 1000, level: 9, name: 'Milionário Natal' },
      { points: 1000000, reward: 5000, level: 10, name: 'Magnata Natal' },
      { points: 1250000, reward: 10000, level: 11, name: 'Barão Natal' },
      { points: 1500000, reward: 25000, level: 12, name: 'Conde Natal' },
      { points: 1750000, reward: 75000, level: 13, name: 'Duque Natal' },
      { points: 2000000, reward: 150000, level: 14, name: 'Imperador Natal' },
      { points: 2500000, reward: 250000, level: 15, name: 'Lenda Natal' },
    ];

    const calcLevelReward = (points: number, levels: typeof dailyLevels): { total: number; lvl: number } => {
      let total = 0;
      let lvl = 0;
      for (const level of levels) {
        if (points >= level.points) {
          total += level.reward;
          lvl = level.level;
        } else break;
      }
      return { total, lvl };
    };

    const calculateRewards = (
      amount: number
    ): {
      daily: number;
      weekly: number;
      total: number;
      dailyLevel: number;
      weeklyLevel: number;
      dailyProgress: number;
      weeklyProgress: number;
    } => {
      const points = amount;

      const daily = calcLevelReward(points, dailyLevels);
      const weekly = calcLevelReward(points, weeklyLevels);

      return {
        daily: daily.total,
        weekly: weekly.total,
        total: daily.total + weekly.total,
        dailyLevel: daily.lvl,
        weeklyLevel: weekly.lvl,
        dailyProgress: Math.min((daily.lvl / 12) * 100, 100),
        weeklyProgress: Math.min((weekly.lvl / 15) * 100, 100),
      };
    };

    const formatCurrency = (value: number): string => {
      try {
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(value);
      } catch {
        return `R$ ${Math.floor(value || 0)}`;
      }
    };

    const updateResults = (): void => {
      const amount = parseFloat((document.getElementById('amountInput') as HTMLInputElement)?.value) || 0;

      const results = calculateRewards(amount);

      const setText = (id: string, value: string): void => {
        document.getElementById(id)!.textContent = value;
      };
      setText('dailyReward', formatCurrency(results.daily));
      setText('dailyLevel', `Nível ${results.dailyLevel} de 12`);
      setText(
        'dailyDetails',
        results.dailyLevel > 0
          ? `${dailyLevels[results.dailyLevel - 1].name} - Prêmios em dinheiro real e freespins`
          : 'Prêmios em dinheiro real e freespins'
      );

      setText('weeklyReward', formatCurrency(results.weekly));
      setText('weeklyLevel', `Nível ${results.weeklyLevel} de 15`);
      setText(
        'weeklyDetails',
        results.weeklyLevel > 0
          ? `${weeklyLevels[results.weeklyLevel - 1].name} - Prêmios acumulados progressivamente`
          : 'Prêmios acumulados progressivamente'
      );

      setText('totalReward', formatCurrency(results.total));

      const setProgress = (idBar: string, idText: string, value: number): void => {
        const bar = document.getElementById(idBar)!;
        bar.style.width = `${value}%`;
        bar.textContent = `${value.toFixed(0)}%`;
        setText(idText, `${value.toFixed(0)}%`);
      };

      setProgress('dailyProgressBar', 'dailyProgress', results.dailyProgress);
      setProgress('weeklyProgressBar', 'weeklyProgress', results.weeklyProgress);
    };

    const setAmount = (value: number): void => {
      (document.getElementById('amountInput') as HTMLInputElement).value = String(value);
      updateResults();
    };

    (window as any).setAmount = setAmount;

    document.getElementById('amountInput')?.addEventListener('input', updateResults);

    updateResults();
  }, []);

  const htmlString = `<!DOCTYPE html>
  <html lang="pt-BR">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>PAPI - Calculadora para High Rollers</title>
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link
        href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Orbitron:wght@700;900&family=DM+Sans:wght@400;500;700&display=swap"
        rel="stylesheet">
      <style>
          :root {
              --gold: #FFD700;
              --gold-dark: #D4AF37;
              --gold-light: #FFED4E;
              --black: #0A0A0A;
              --dark-gray: #1A1A1A;
              --medium-gray: #2A2A2A;
              --red: #DC2626;
              --green: #10B981;
              --white: #FFFFFF;
              --platinum: #E5E7EB;
          }
          
          * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
          }
          
          body {
              font-family: 'DM Sans', sans-serif;
              background: var(--black);
              color: var(--white);
              overflow-x: hidden;
              line-height: 1.6;
          }
          
          /* Animated luxury background */
          .bg-animation {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 0;
              opacity: 0.08;
              background: 
                  radial-gradient(circle at 20% 30%, var(--gold) 0%, transparent 40%),
                  radial-gradient(circle at 80% 70%, var(--gold-dark) 0%, transparent 40%),
                  radial-gradient(circle at 50% 50%, var(--platinum) 0%, transparent 60%);
              animation: pulse 10s ease-in-out infinite;
          }
          
          @keyframes pulse {
              0%, 100% { opacity: 0.08; transform: scale(1); }
              50% { opacity: 0.15; transform: scale(1.05); }
          }
          
          /* Header */
          header {
              position: relative;
              z-index: 10;
              padding: 2rem 5%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 2px solid rgba(255, 215, 0, 0.3);
              background: rgba(10, 10, 10, 0.8);
              backdrop-filter: blur(10px);
          }
          
          .logo {
              font-family: 'Orbitron', sans-serif;
              font-size: 3rem;
              font-weight: 900;
              background: linear-gradient(135deg, var(--gold), var(--platinum), var(--gold));
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-shadow: 0 0 30px rgba(255, 215, 0, 0.5);
              letter-spacing: 0.15em;
          }
          
          .vip-badge {
              padding: 0.75rem 2rem;
              background: linear-gradient(135deg, var(--gold), var(--gold-dark));
              color: var(--black);
              font-weight: 700;
              font-size: 0.9rem;
              border-radius: 50px;
              text-transform: uppercase;
              letter-spacing: 0.1em;
              box-shadow: 0 5px 25px rgba(255, 215, 0, 0.4);
          }
          
          /* Hero */
          .hero {
              position: relative;
              z-index: 1;
              padding: 6rem 5% 4rem;
              text-align: center;
          }
          
          .hero-title {
              font-family: 'Orbitron', sans-serif;
              font-size: clamp(2.5rem, 7vw, 6rem);
              font-weight: 900;
              line-height: 1;
              margin-bottom: 1.5rem;
              background: linear-gradient(135deg, var(--gold), var(--platinum), var(--gold));
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              animation: fadeInUp 1s ease;
          }
          
          .hero-subtitle {
              font-size: clamp(1.2rem, 2.5vw, 1.8rem);
              margin-bottom: 3rem;
              color: var(--gold);
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.1em;
              animation: fadeInUp 1s ease 0.2s backwards;
          }
          
          @keyframes fadeInUp {
              from {
                  opacity: 0;
                  transform: translateY(30px);
              }
              to {
                  opacity: 1;
                  transform: translateY(0);
              }
          }
          
          /* Case Study Banner */
          .case-study-banner {
              position: relative;
              z-index: 1;
              margin: 0 5% 4rem;
              padding: 3rem;
              background: linear-gradient(135deg, rgba(212, 175, 55, 0.15), rgba(26, 26, 26, 0.9));
              border: 2px solid var(--gold);
              border-radius: 20px;
              box-shadow: 0 10px 50px rgba(255, 215, 0, 0.2);
          }
          
          .case-study-label {
              display: inline-block;
              padding: 0.5rem 1.5rem;
              background: var(--gold);
              color: var(--black);
              font-weight: 700;
              font-size: 0.9rem;
              border-radius: 30px;
              margin-bottom: 1.5rem;
              text-transform: uppercase;
              letter-spacing: 0.1em;
          }
          
          .case-study-title {
              font-family: 'Orbitron', sans-serif;
              font-size: clamp(1.8rem, 4vw, 3rem);
              font-weight: 900;
              color: var(--gold);
              margin-bottom: 2rem;
          }
          
          .case-study-stats {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 2rem;
          }
          
          .stat-box {
              text-align: center;
              padding: 2rem;
              background: rgba(0, 0, 0, 0.5);
              border-radius: 15px;
              border: 1px solid rgba(255, 215, 0, 0.3);
          }
          
          .stat-value {
              font-family: 'Orbitron', sans-serif;
              font-size: 2.5rem;
              font-weight: 900;
              color: var(--green);
              margin-bottom: 0.5rem;
          }
          
          .stat-label {
              font-size: 1rem;
              color: var(--platinum);
              text-transform: uppercase;
              letter-spacing: 0.05em;
          }
          
          .stat-detail {
              font-size: 0.9rem;
              color: rgba(255, 255, 255, 0.7);
              margin-top: 0.5rem;
          }
          
          /* Calculator Section */
          .calculator-section {
              position: relative;
              z-index: 1;
              padding: 4rem 5%;
              max-width: 1400px;
              margin: 0 auto;
          }
          
          .section-title {
              font-family: 'Orbitron', sans-serif;
              font-size: clamp(2rem, 4vw, 3.5rem);
              text-align: center;
              margin-bottom: 1rem;
              background: linear-gradient(135deg, var(--gold), var(--platinum));
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              font-weight: 900;
          }
          
          .section-subtitle {
              text-align: center;
              font-size: 1.2rem;
              color: rgba(255, 255, 255, 0.7);
              margin-bottom: 4rem;
          }
          
          .calculator-container {
              background: linear-gradient(135deg, var(--dark-gray), var(--medium-gray));
              border: 2px solid var(--gold);
              border-radius: 25px;
              padding: 3rem;
              box-shadow: 0 20px 60px rgba(255, 215, 0, 0.3);
          }
          
          .input-section {
              margin-bottom: 3rem;
          }
          
          .input-label {
              font-family: 'Orbitron', sans-serif;
              font-size: 1.3rem;
              font-weight: 700;
              color: var(--gold);
              margin-bottom: 1.5rem;
              display: block;
              text-transform: uppercase;
              letter-spacing: 0.05em;
          }
          
          .input-group {
              display: flex;
              align-items: center;
              gap: 1.5rem;
              margin-bottom: 1rem;
          }
          
          .currency-symbol {
              font-family: 'Orbitron', sans-serif;
              font-size: 2rem;
              color: var(--gold);
              font-weight: 700;
          }
          
          .amount-input {
              flex: 1;
              padding: 1.5rem;
              font-size: 2rem;
              font-family: 'Orbitron', sans-serif;
              font-weight: 700;
              background: rgba(0, 0, 0, 0.5);
              border: 2px solid var(--gold);
              border-radius: 15px;
              color: var(--gold);
              text-align: center;
              width: 100%;
          }
          
          .amount-input:focus {
              outline: none;
              border-color: var(--gold-light);
              box-shadow: 0 0 20px rgba(255, 215, 0, 0.4);
          }
          
          .quick-amounts {
              display: flex;
              gap: 1rem;
              flex-wrap: wrap;
              justify-content: center;
              margin-top: 1.5rem;
          }
          
          .quick-btn {
              padding: 0.75rem 1.5rem;
              background: rgba(255, 215, 0, 0.1);
              border: 1px solid var(--gold);
              border-radius: 30px;
              color: var(--gold);
              font-weight: 600;
              cursor: pointer;
              transition: all 0.3s ease;
          }
          
          .quick-btn:hover {
              background: var(--gold);
              color: var(--black);
              transform: translateY(-2px);
          }
          
          /* Results Grid */
          .results-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
              gap: 2rem;
              margin-top: 3rem;
          }
          
          .result-card {
              background: rgba(0, 0, 0, 0.6);
              border: 2px solid transparent;
              border-radius: 20px;
              padding: 2.5rem;
              transition: all 0.4s ease;
          }
          
          .result-card:hover {
              border-color: var(--gold);
              transform: translateY(-5px);
              box-shadow: 0 15px 40px rgba(255, 215, 0, 0.3);
          }
          
          .result-icon {
              font-size: 3rem;
              margin-bottom: 1rem;
          }
          
          .result-title {
              font-family: 'Orbitron', sans-serif;
              font-size: 1.5rem;
              font-weight: 700;
              color: var(--gold);
              margin-bottom: 1rem;
              text-transform: uppercase;
              letter-spacing: 0.05em;
          }
          
          .result-amount {
              font-family: 'Orbitron', sans-serif;
              font-size: 3rem;
              font-weight: 900;
              color: var(--green);
              margin-bottom: 1rem;
          }
          
          .result-details {
              color: rgba(255, 255, 255, 0.7);
              line-height: 1.8;
          }
          
          .result-level {
              display: inline-block;
              padding: 0.5rem 1rem;
              background: rgba(255, 215, 0, 0.2);
              border: 1px solid var(--gold);
              border-radius: 20px;
              font-size: 0.9rem;
              color: var(--gold);
              margin-top: 1rem;
              font-weight: 600;
          }
          
          /* Progress visualization */
          .progress-section {
              margin-top: 3rem;
              padding: 2.5rem;
              background: rgba(0, 0, 0, 0.4);
              border-radius: 20px;
              border: 1px solid rgba(255, 215, 0, 0.3);
          }
          
          .progress-title {
              font-family: 'Orbitron', sans-serif;
              font-size: 1.5rem;
              color: var(--gold);
              margin-bottom: 2rem;
              text-align: center;
          }
          
          .progress-bar-container {
              margin-bottom: 2.5rem;
          }
          
          .progress-label {
              display: flex;
              justify-content: space-between;
              margin-bottom: 0.5rem;
              font-size: 0.9rem;
              color: rgba(255, 255, 255, 0.8);
          }
          
          .progress-bar {
              height: 30px;
              background: rgba(0, 0, 0, 0.5);
              border-radius: 15px;
              overflow: hidden;
              border: 1px solid var(--gold);
          }
          
          .progress-fill {
              height: 100%;
              background: linear-gradient(90deg, var(--gold-dark), var(--gold), var(--gold-light));
              transition: width 1s ease;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-right: 10px;
              font-weight: 700;
              color: var(--black);
              font-size: 0.9rem;
          }
          
          /* CTA Section */
          .cta-section {
              position: relative;
              z-index: 1;
              padding: 6rem 5%;
              text-align: center;
              background: linear-gradient(180deg, transparent, rgba(26, 26, 26, 0.8));
          }
          
          .cta-title {
              font-family: 'Orbitron', sans-serif;
              font-size: clamp(2.5rem, 5vw, 4rem);
              font-weight: 900;
              margin-bottom: 2rem;
              background: linear-gradient(135deg, var(--gold), var(--platinum), var(--gold));
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
          }
          
          .cta-button {
              display: inline-block;
              padding: 1.5rem 4rem;
              background: linear-gradient(135deg, var(--gold), var(--gold-dark));
              color: var(--black);
              font-weight: 700;
              font-size: 1.5rem;
              border: none;
              border-radius: 50px;
              cursor: pointer;
              text-decoration: none;
              transition: all 0.3s ease;
              box-shadow: 0 10px 40px rgba(255, 215, 0, 0.4);
              font-family: 'Orbitron', sans-serif;
              letter-spacing: 0.05em;
              text-transform: uppercase;
          }
          
          .cta-button:hover {
              transform: translateY(-5px) scale(1.05);
              box-shadow: 0 15px 50px rgba(255, 215, 0, 0.6);
          }
          
          /* Footer */
          footer {
              position: relative;
              z-index: 1;
              padding: 2rem 5%;
              border-top: 1px solid rgba(255, 215, 0, 0.2);
              text-align: center;
              color: rgba(255, 255, 255, 0.5);
          }
          
          /* Responsive */
          @media (max-width: 768px) {
              .logo {
                  font-size: 2rem;
              }
              
              .case-study-stats {
                  grid-template-columns: 1fr;
              }
              
              .input-group {
                  flex-direction: column;
              }
              
              .quick-amounts {
                  flex-direction: column;
              }
              
              .quick-btn {
                  width: 100%;
              }
          }
      </style>
  </head>
  <body>
      <div class="bg-animation"></div>
      
      <header>
          <div class="logo">PAPI</div>
          <div class="vip-badge">High Roller Exclusive</div>
      </header>
      
      <section class="hero">
          <h1 class="hero-title">CALCULADORA<br>HIGH ROLLER</h1>
          <p class="hero-subtitle">Sistema Premium para Grandes Jogadores</p>
      </section>
      
      <!-- Case Study Banner -->
      <div class="case-study-banner">
          <div class="case-study-label">⭐ CASO REAL</div>
          <h2 class="case-study-title">smaikcaio em Apenas 2 Horas</h2>
          <div class="case-study-stats">
              <div class="stat-box">
                  <div class="stat-value">R$ 200.000</div>
                  <div class="stat-label">Vitória nos Jogos</div>
                  <div class="stat-detail">Grande sessão de slots</div>
              </div>
              <div class="stat-box">
                  <div class="stat-value">R$ 1.934</div>
                  <div class="stat-label">Desafio Diário</div>
                  <div class="stat-detail">8 níveis desbloqueados</div>
              </div>
              <div class="stat-box">
                  <div class="stat-value">R$ 934</div>
                  <div class="stat-label">Desafio Semanal</div>
                  <div class="stat-detail">8 níveis + 50% completo</div>
              </div>
              <div class="stat-box">
                  <div class="stat-value">R$ 2.868</div>
                  <div class="stat-label">Bônus Total PAPI</div>
                  <div class="stat-detail">Além da vitória de R$ 200k</div>
              </div>
          </div>
      </div>
      
      <!-- Calculator -->
      <section class="calculator-section">
          <h2 class="section-title">Calcule Seus Prêmios</h2>
          <p class="section-subtitle">Insira quanto você joga e veja quanto você ganha em recompensas</p>
          
          <div class="calculator-container">
              <div class="input-section">
                  <label class="input-label">Quanto Você Joga?</label>
                  <div class="input-group">
                      <span class="currency-symbol">R$</span>
                      <input type="number" id="amountInput" class="amount-input" placeholder="0" value="100000" min="0" step="1000">
                  </div>
                  <div class="quick-amounts">
                      <button class="quick-btn" onclick="setAmount(10000)">R$ 10.000</button>
                      <button class="quick-btn" onclick="setAmount(50000)">R$ 50.000</button>
                      <button class="quick-btn" onclick="setAmount(100000)">R$ 100.000</button>
                      <button class="quick-btn" onclick="setAmount(250000)">R$ 250.000</button>
                      <button class="quick-btn" onclick="setAmount(500000)">R$ 500.000</button>
                      <button class="quick-btn" onclick="setAmount(1000000)">R$ 1.000.000</button>
                  </div>
              </div>
              
              <div class="results-grid">
                  <div class="result-card">
                      <div class="result-icon">📅</div>
                      <div class="result-title">Desafio Diário</div>
                      <div class="result-amount" id="dailyReward">R$ 0</div>
                      <div class="result-details" id="dailyDetails">
                          Prêmios em dinheiro real e freespins
                      </div>
                      <div class="result-level" id="dailyLevel">Nível 0 de 12</div>
                  </div>
                  
                  <div class="result-card">
                      <div class="result-icon">📊</div>
                      <div class="result-title">Desafio Semanal</div>
                      <div class="result-amount" id="weeklyReward">R$ 0</div>
                      <div class="result-details" id="weeklyDetails">
                          Prêmios acumulados progressivamente
                      </div>
                      <div class="result-level" id="weeklyLevel">Nível 0 de 15</div>
                  </div>
                  
                  <div class="result-card">
                      <div class="result-icon">💰</div>
                      <div class="result-title">Total Prêmios PAPI</div>
                      <div class="result-amount" id="totalReward">R$ 0</div>
                      <div class="result-details">
                          Soma dos dois desafios<br>
                          <strong style="color: var(--gold);">Além das suas vitórias nos jogos!</strong>
                      </div>
                  </div>
              </div>
              
              <!-- Progress Bars -->
              <div class="progress-section">
                  <div class="progress-title">Progressão nos Níveis</div>
                  
                  <div class="progress-bar-container">
                      <div class="progress-label">
                          <span>Desafio Diário</span>
                          <span id="dailyProgress">0%</span>
                      </div>
                      <div class="progress-bar">
                          <div class="progress-fill" id="dailyProgressBar" style="width: 0%">0%</div>
                      </div>
                  </div>
                  
                  <div class="progress-bar-container">
                      <div class="progress-label">
                          <span>Desafio Semanal</span>
                          <span id="weeklyProgress">0%</span>
                      </div>
                      <div class="progress-bar">
                          <div class="progress-fill" id="weeklyProgressBar" style="width: 0%">0%</div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      
      <!-- CTA -->
      <section class="cta-section">
          <h2 class="cta-title">Pronto para Jogar no Topo?</h2>
          <a
           href="${btnUrl}" 
           target="_blank" 
           rel="noopener noreferrer" 
           class="cta-button">
            Entre Agora
          </a>
      </section>
      
      <footer>
          <p>&copy; 2024 PAPI.BET.BR - Jogo responsável 18+ | Sistema exclusivo para high rollers</p>
      </footer>
  </body>
  </html>`;
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
};

export default Calculadoradenatalmetapapi;
